export const BASE_URL_API = "https://facture.ets-dms-senke.com";  
// export const BASE_URL_API = "http://127.0.0.1:8000";

export const PRIMARY_COLOR ="#004897";